import { render, staticRenderFns } from "./CaseSteps.vue?vue&type=template&id=3c6f1a6a&scoped=true&"
import script from "./CaseSteps.vue?vue&type=script&lang=ts&"
export * from "./CaseSteps.vue?vue&type=script&lang=ts&"
import style0 from "./CaseSteps.vue?vue&type=style&index=0&id=3c6f1a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f1a6a",
  null
  
)

export default component.exports